angular.module('EdxReportCommonModule')
  .directive('edxStatsPane', function() {
    return {
      restrict: 'E',
      scope: {
        edxItemStats: '=',
        edxHideGrowth: '@'
      },
      templateUrl: '/resources/components/report/common/stats-pane/edx-stats-pane.directive.html',
      controller: [
        '$scope',
        'dblUsageStatus',
        function(
          $scope,
          dblUsageStatus) {

          $scope.getStatusStyle = function(status) {
            return "text-" + dblUsageStatus.getStatusString(status);
          };

        }
      ]
    };
  });